<template>
<div>
	<v-dialog v-model="dialog"
		persistent
		max-width="500px"
	>
		<v-card>
			<v-card-title>
				<span class="headline">{{$t('workers.add_worker_skan')}}</span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap>
						<v-flex xs12 sm6 md6>
							<v-text-field :label="$t('workers.number_document')"
								v-model="dialogForm.document_number"
							/>
						</v-flex>
						<v-flex xs12 sm6 md6 d-flex>
							<v-select
								:items="scanTypes"
								:label="$t('workers.type')"
								v-model="dialogForm.type"
								item-value="key"
								item-text="value"
							/>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex xs12 sm12 md12>
							<v-text-field :label="$t('workers.issuer')"
								v-model="dialogForm.issuer"
							/>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex xs12 sm6 md6>
							<DatePicker
								:label="$t('workers.issued_at')"
								v-model="dialogForm.issued_at"
							/>
						</v-flex>
						<v-flex xs12 sm6 md6>
							<DatePicker
								:label="$t('workers.invalid_at')"
								v-model="dialogForm.invalid_at"
							/>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn color="red darken-1" flat @click="cancel">{{$t('common.close')}}</v-btn>
				<v-btn color="green darken-1" flat @click="save">{{$t('common.save')}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import DatePicker from '../../../../components/DatePicker'

export default {
	components: {
		DatePicker
	},
	props: {
		dialogForm: Object,
		dialog: Boolean
	},
	methods: {
		save() {
			this.$emit('save')
		},
		cancel() {
			this.$emit('cancel')
		}
	},
	computed: {
		...mapGetters({
			scanTypes: 'settings/scanTypes'
		})
	}
}
</script>

<style scoped>
.btn-add {
	margin: 30px 70px 30px 0;
}
</style>
